import React, { Component } from 'react';
import { Divider, Dimmer, Loader, Responsive, Button, Input, Message, Popup, Modal, Dropdown, Radio, Icon } from 'semantic-ui-react';
import { nextPaymentURL } from "../../shared/urls/clientapi";
import { callService, GET, PATCH } from "../../shared/serviceInvoker";
import FormatCurrency from "../FormatCurrency";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';
import DepositInfoModal from "../DepositInfoModal";
import {DOLLAR_FORMAT} from "../../shared/helpers/formats";
import ContactUs from "../../shared/components/ContactUs";

export default class DepositsList extends Component {

  constructor() {
    super();
    this.state = { 
      showLoader: true, 
      fontSize: 'divLeft divFont50', 
      showChangePaymentFields: false,
      showChangePaymentButton: false,
      validationItems: [],
      originalNewPaymentDate: '',
      originalNewPaymentAmount: '',
      newPaymentDate: '', 
      newPaymentAmount: 0.00,
      nextPaymentAmount: 0.00,
      nextPaymentDateLabel: '',
      minPaymentDate: '',
      maxPaymentDate: '',
      success: false,
      error: false,      
      disableChangeDeposit: false,
      disableSaveChanges: false,
      minPaymentAmountValidation: '',
      minPaymentAmount: 0.00,
      adjustmentModalOpen: false,
      reductionAmount: 0.00,
      addToMonthAmount: 0.00,
      nextPaymentsCount: 0,
      monthCount: 0,
      selectedAdjustmentMonth: 0,
      selectedAdjustmentType: '',
      extendProgramDate: '',
      extendProgramDateLabel: '',
      adjustmentPlanErrors: false,
      disableSkipDeposit: false,
      skipPayment: false,
      datepickerFormat: '',
      datepickerClassName: '',
      newAmountPlaceholder: '',
      newAmountClassName: '',
      btnSize: 'medium',
      totalDeposits: 0,
      consecutiveDeposits: 0,
      remainingDeposits: 0
    }

    this.changePayment = this.changePayment.bind(this);
    this.cancelChanges = this.cancelChanges.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.savePlanAdjustmentChanges = this.savePlanAdjustmentChanges.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.closeAdjustmentModal = this.closeAdjustmentModal.bind(this);
    this.handleOnAdjustmentMonthChange = this.handleOnAdjustmentMonthChange.bind(this);
    this.handleOnAdjustmentTypeChange = this.handleOnAdjustmentTypeChange.bind(this);
    this.skipDeposit = this.skipDeposit.bind(this);
  }

  componentDidMount() {
    var contact_id = "";
    if (sessionStorage.getItem("contact_id")) {
      contact_id = sessionStorage.getItem("contact_id");
    }

    this.populatePaymentInfo(contact_id);
  }

  populatePaymentInfo(contact_id) {
    callService(
      GET,
      nextPaymentURL.replace('{contact_id}', contact_id),
      null,
      response => {
        let result = response.data.data;
        this.setState({ 
          showLoader: false, 
          originalNewPaymentDate: new Date(result.newPaymentDate),
          originalNewPaymentAmount: result.newPaymentAmount,
          newPaymentDate: new Date(result.newPaymentDate),
          minPaymentDate: new Date(result.minPaymentDate),
          maxPaymentDate: new Date(result.maxPaymentDate),
          newPaymentAmount: result.newPaymentAmount,
          nextPaymentAmount: result.nextPaymentAmount,
          nextPaymentDateLabel: result.nextPaymentDateLabel,
          showChangePaymentButton: result.showChangePaymentButton,
          disableChangeDeposit: result.disableChangeDeposit,
          minPaymentAmountValidation: result.minPaymentAmountValidation,
          minPaymentAmount: result.minPaymentAmount,
          nextPaymentsCount: result.nextPaymentsCount,
          extendProgramDate: result.extendProgramDate,
          extendProgramDateLabel: result.extendProgramDateLabel,
          disableSkipDeposit: result.disableSkipDeposit,
          inSettlement: result.inSettlement,
          totalDeposits: result.totalDeposits,
          consecutiveDeposits: result.consecutiveDeposits,
          remainingDeposits: result.remainingDeposits
        });
      },
      error => {
        this.setState({ 
          nextPaymentAmount: 0,
          nextPaymentDateLabel: 'N/A', 
          showLoader: false, 
          newPaymentDate: new Date() 
        });
      }
    );
  }

  handleOnAdjustmentMonthChange = (e, data) => {
    let newAmount = this.state.skipPayment ? 0 : this.state.newPaymentAmount;
    let reductionAmount = (this.state.nextPaymentAmount - newAmount).toFixed(2);    
    let addToMonthAmount = (reductionAmount / data.value).toFixed(2);
    this.setState({selectedAdjustmentMonth: data.value, addToMonthAmount: addToMonthAmount});
  };

  handleOnAdjustmentTypeChange = (e, data) => {
    this.setState({selectedAdjustmentType: data.value, adjustmentPlanErrors: false});
  };

  handleOnUpdate = (e, { width }) => {
    let fontSize = width >= Responsive.onlyTablet.minWidth ? 'divLeft divFont50' : 'divLeft divFont25';        
    let datepickerFormat;
    let datepickerClassName;
    let btnSize;
    let newAmountPlaceholder = width < 360 ? 'Amount' : 'New Amount';
    let newAmountClassName = width <  360 ? 'input-payment-amount-mobile' : 'input-payment-amount';

    if (width < 360){
      datepickerFormat = 'M/d/yy'
      datepickerClassName = 'datepicker-input-mobile';
      btnSize = 'tiny';
    }else{
      datepickerFormat = width >= Responsive.onlyTablet.minWidth ? 'MMMM d, yyyy' : 'MMM d, yyyy';
      datepickerClassName = width >= Responsive.onlyTablet.minWidth ? 'datepicker-input' : 'datepicker-input-tablet';
      btnSize = width >= Responsive.onlyTablet.minWidth ? 'medium' : 'small';
    }

    this.setState({ 
      fontSize: fontSize, 
      datepickerFormat: datepickerFormat, 
      datepickerClassName: datepickerClassName,
      newAmountPlaceholder: newAmountPlaceholder,
      newAmountClassName: newAmountClassName,
      btnSize: btnSize
    });
  }

  handleDateChange(date) {
    this.setState({
      newPaymentDate: date
    });
  }

  handleAmountChange(event) {
    const target = event.target;
    const value = target.value;
    const newAmount = (target.validity.valid) ? value : this.state.newPaymentAmount;
    const minAmount = this.state.minPaymentAmount;
    let errorList = [];
    let disableSaveChanges = false;    
        
    if (newAmount < minAmount) {
      disableSaveChanges = true;   
      errorList.push(
        <span>
          The amount of your deposit must be at least {DOLLAR_FORMAT.format(minAmount)} to maintain your program’s schedule. 
          Please <ContactUs /> to arrange any deposit changes below this amount.
        </span>
      );      
    }

    this.setState({ 
      newPaymentAmount: newAmount, 
      disableSaveChanges: disableSaveChanges,
      validationItems: errorList
    });
  }

  changePayment() {
    this.setState({showChangePaymentFields:true, success: false, error: false})
    
    ReactGA.event({
      category: 'Deposit',
      action: 'Change Deposit clicked',
    });
    trackEvent('Deposit', 'Change Deposit clicked');
  }

  cancelChanges() {    
    this.setState({
      showChangePaymentFields:false, 
      validationItems: [],
      newPaymentDate: this.state.originalNewPaymentDate,
      newPaymentAmount: this.state.originalNewPaymentAmount,
      disableSaveChanges: false
    })

    ReactGA.event({
      category: 'Deposit',
      action: 'Cancel Changes clicked',
    });    
    trackEvent('Deposit', 'Cancel Changes clicked');
  }

  skipDeposit() {
    let reductionAmount = (this.state.nextPaymentAmount).toFixed(2);
    let addToMonthAmount = 0.00;
    let nextPaymentsCount = this.state.nextPaymentsCount;
    let monthCount = 0;
    let monthOptions = [];

    if (nextPaymentsCount > 1){
      monthCount = nextPaymentsCount >= 7 ? 6 : nextPaymentsCount -1;
      addToMonthAmount = (reductionAmount / monthCount).toFixed(2);
      for (let i = 0; i < monthCount; i++) {
        monthOptions.push({ key: i + 1, text: i + 1, value: i + 1 })
      }
    }

    this.setState({
      adjustmentModalOpen: true, 
      addToMonthAmount: addToMonthAmount, 
      reductionAmount:reductionAmount, 
      monthCount: monthCount,
      monthOptions: monthOptions,
      selectedAdjustmentMonth: monthCount,
      validationItems: [],
      newPaymentDate: this.state.originalNewPaymentDate,
      newPaymentAmount: this.state.originalNewPaymentAmount,
      disableSaveChanges: false,
      skipPayment: true
    });
  }

  saveChanges() {    
    let errorList = [];
    const { minPaymentDate, newPaymentDate, newPaymentAmount, maxPaymentDate} = this.state;
    let newDate;
    let minDate;
    let maxDate;

    ReactGA.event({
      category: 'Deposit',
      action: 'Save Changes clicked',
    });
    trackEvent('Deposit', 'Save Changes clicked');

    if (newPaymentDate == null){
      errorList.push('Please select a date at least 2 days from today');      
    } else {
      minDate = moment(minPaymentDate).format('YYYY-MM-DD');
      newDate = moment(newPaymentDate).format('YYYY-MM-DD');
      if (newDate < minDate){
        errorList.push('Please select a date at least 2 days from today');
      }

      maxDate = moment(maxPaymentDate).format('YYYY-MM-DD');
      if (newDate > maxDate){
        errorList.push('Please select a valid date from the available options');
      }
    }    

    if (newPaymentAmount <= 0){
      errorList.push('Please select an amount greater than $0.00');
    }
    this.setState({validationItems: errorList, skipPayment: false});

    if (errorList.length === 0){
      if (this.state.newPaymentAmount < this.state.nextPaymentAmount){
        let reductionAmount = (this.state.nextPaymentAmount - this.state.newPaymentAmount).toFixed(2);
        let addToMonthAmount = 0.00;
        let nextPaymentsCount = this.state.nextPaymentsCount;
        let monthCount = 0;
        let monthOptions = [];

        if (nextPaymentsCount > 1){
          monthCount = nextPaymentsCount >= 7 ? 6 : nextPaymentsCount -1;
          addToMonthAmount = (reductionAmount / monthCount).toFixed(2);
          for (let i = 0; i < monthCount; i++) {
            monthOptions.push({ key: i + 1, text: i + 1, value: i + 1 })
          }
        }

        this.setState({
          adjustmentModalOpen: true, 
          addToMonthAmount: addToMonthAmount, 
          reductionAmount:reductionAmount, 
          monthCount: monthCount,
          monthOptions: monthOptions,
          selectedAdjustmentMonth: monthCount
        });
      } else {
        this.sendChangePaymentInfo();
      }
    }
  }

  savePlanAdjustmentChanges(){
    let adjustmentPlanErrors = false;
    let adjustmentModalOpen = false;
    let sendAdjustmentInfo = true;
   
    if (this.state.selectedAdjustmentType === ''){
      adjustmentPlanErrors = true;
      adjustmentModalOpen = true;
      sendAdjustmentInfo = false;
    } 
    this.setState({adjustmentModalOpen: adjustmentModalOpen, adjustmentPlanErrors: adjustmentPlanErrors});

    if (sendAdjustmentInfo){
      this.sendChangePaymentInfo();
    }
  }

  sendChangePaymentInfo(){
      let contact_id = "";
      let newDate = moment(this.state.newPaymentDate).format('YYYY-MM-DD');
      if (sessionStorage.getItem("contact_id")) {
        contact_id = sessionStorage.getItem("contact_id");
      }

      let bodyFormData = new FormData();
      bodyFormData.append('amount', this.state.newPaymentAmount);
      bodyFormData.append('date', newDate);
      bodyFormData.append('adjustment_type', this.state.selectedAdjustmentType);
      bodyFormData.append('adjustment_month', this.state.selectedAdjustmentMonth);
      bodyFormData.append('add_to_month_amount', this.state.addToMonthAmount);
      bodyFormData.append('extend_program_date', this.state.extendProgramDate);
      bodyFormData.append('reduction_amount', this.state.reductionAmount);
      bodyFormData.append('skip_payment', this.state.skipPayment)

      callService(
        PATCH,
        nextPaymentURL.replace('{contact_id}', contact_id),
        bodyFormData,
        response => {
          this.setState({ 
            showChangePaymentFields:false, 
            success: true, 
            error: false, 
            selectedAdjustmentType: '',
            disableChangeDeposit: true,
            disableSkipDeposit: true
          });
          
          ReactGA.event({
            category: 'Deposit',
            action: 'Next Deposit Changed',
          });
          trackEvent('Deposit', 'Next Deposit Changed', 'date', newDate);
          trackEvent('Deposit', 'Next Deposit Changed', 'amount', this.state.newPaymentAmount);

          this.populatePaymentInfo(contact_id);
        },
        error => {
          if (error.response.data.detail !== undefined){
            var validationErrors = error.response.data.detail;
            var arrayLength = validationErrors.length;
            let errorList = [];
            for (var i = 0; i < arrayLength; i++) {
                errorList.push(validationErrors[i]);
            }
            this.setState({validationItems: errorList});
          }
          else{
            this.setState({ showChangePaymentFields:false, success: false, error: true });
          }
        }
      );
  }

  closeAdjustmentModal() {
    this.setState({adjustmentModalOpen: false, selectedAdjustmentType: '', adjustmentPlanErrors: false, skipPayment: false});
  }

  render() {
    const number_pattern = '\\d[0-9]*(\\.)?(\\d{1,2})?'
    const { 
      showLoader, 
      fontSize, 
      validationItems, 
      nextPaymentDateLabel, 
      showChangePaymentFields, 
      newPaymentDate, 
      minPaymentDate,
      maxPaymentDate,
      newPaymentAmount,
      success,
      error,
      showChangePaymentButton,
      nextPaymentAmount,
      disableChangeDeposit,
      disableSaveChanges, 
      adjustmentModalOpen,
      reductionAmount,
      addToMonthAmount,
      monthCount,
      monthOptions,
      selectedAdjustmentMonth,
      extendProgramDateLabel,
      selectedAdjustmentType,
      adjustmentPlanErrors,
      disableSkipDeposit,
      inSettlement,
      datepickerFormat,
      datepickerClassName,
      newAmountPlaceholder,
      newAmountClassName,
      btnSize,
      totalDeposits,
      consecutiveDeposits,
      remainingDeposits
    } = this.state;
    const PageLoader = () => (
      <Dimmer active={showLoader} inverted>
        <Loader size='medium'>Loading Deposits ...</Loader>
      </Dimmer>
    )

    const SaveChangesPopup = () => (
      <div>
        To make sure your program proceeds as scheduled, only one online deposit change can be made every 6 months. 
        Please <ContactUs /> to arrange any further deposit changes needed.
      </div>
    ) 

    const SkipDepositPopup = () => (
      <div>
        To make sure your program proceeds as scheduled, only one online deposit skip can be made every 12 months.         
        Please <ContactUs /> to arrange any further deposit changes needed.
      </div>
    ) 

    const InSettlementPopup = () => (
      <div>
        Since you currently have a settlement in progress, any changes to your deposit might have severe consequences with your creditor.         
        Please <ContactUs /> to arrange any further deposit changes needed.
      </div>
    ) 

    return (
      <div>
        <div>
          <b>DEPOSITS</b>
          <span className="divRight">
            <table>
              <tbody>
                <tr>
                  <td align="right"> 
                    Total Deposits: {totalDeposits}<br />
                    Consecutive Deposits: {consecutiveDeposits}<br />
                    Remaining Deposits: {remainingDeposits}
                  </td>
                  <td>
                    <Popup position='top center' trigger={<Icon circular link name='info' size="small" />} on='click' hideOnScroll wide>
                      <p>
                        Deposits are a crucial part of your program. The more deposits you’re able to make, the sooner your debts can be settled and the closer you’ll become to your goal of becoming debt free. These numbers represent your success so far towards that goal.
                      </p>
                      <p>
                        Total Deposits reflects the total number of successful deposits you’ve made into the program.
                      </p>
                      <p>
                        Consecutive Deposits reflects the number of successful deposits you’ve made in a row.
                      </p>
                      <p>
                        Remaining Deposits reflects the number of remaining deposits currently scheduled for your program (including any payments currently in process).
                      </p>
                      <p>
                        For specific deposit information, <ContactUs /> for assistance.
                      </p>
                    </Popup>
                  </td>
                </tr>
              </tbody>              
            </table>              
          </span>
        </div>
        
        <br /><br /><br />
        <Divider fitted />
        <PageLoader />
        <br />
        <div className="divLeftHeight50">
          Next Deposit Date
        <span className="divRight">Next Deposit Amount</span>
        </div>
        <Responsive fireOnMount onUpdate={this.handleOnUpdate}>
        <div className={fontSize}>
          {nextPaymentDateLabel}
          <span className="divRight">
            <FormatCurrency amount={nextPaymentAmount} />
          </span>
        </div>
        {
          showChangePaymentFields ?
          <span>
            <div className="change-payment-padding">
              <DatePicker 
                placeholderText="New Date"
                dateFormat={datepickerFormat}
                selected={newPaymentDate} 
                onChange={this.handleDateChange} 
                minDate={minPaymentDate}
                maxDate={maxPaymentDate}  
                disabled={disableChangeDeposit}                          
                className={datepickerClassName}
              />              
              <span className="divRight">
                {
                  disableSkipDeposit ?       
                    <Popup wide hoverable content={<SkipDepositPopup />} 
                      trigger={<span><Button size="mini" primary compact disabled content='Skip Deposit' /></span>} 
                    />             
                    : 
                      <Button size="mini" primary compact onClick={this.skipDeposit} content='Skip Deposit' />                  
                }
                <Input type='text' onChange={this.handleAmountChange} disabled={disableChangeDeposit}
                  pattern={number_pattern} icon='dollar sign' placeholder={newAmountPlaceholder}
                  iconPosition='left' name='newPaymentAmount' value={newPaymentAmount} 
                  className={newAmountClassName} />
              </span>
              {
                validationItems.length > 0 ?
                  <Message size="tiny" error>
                    <Message.Header>Validation Error(s):</Message.Header>
                    <ul className='list'>
                      {
                        validationItems.map(function(item, index){
                          return <li className='content' key={index}>{item}</li>;
                        })
                      }
                    </ul>
                    </Message>
                  : null
              }  
            </div>              
            <div>
              <Button negative size={btnSize} onClick={this.cancelChanges}>
                Cancel Changes
              </Button>
              <DepositInfoModal />

              <span className="divRight">
                {
                  disableChangeDeposit ?       
                    <Popup wide hoverable content={<SaveChangesPopup />} 
                      trigger={<span><Button primary disabled size={btnSize} content='Save Changes' /></span>} 
                    />                              
                    : 
                    <Button primary onClick={this.saveChanges} disabled={disableSaveChanges} size={btnSize} content='Save Changes' />
                }
              </span>
            </div>
          </span>  
          : null
        }
        <div>
          {
            success ?              
              <div className="change-payment-success">Your payment information was updated successfully.</div>
              : null
          }
          {
            error ?
              <div className="change-payment-error">Oops, something went wrong! Please try again in a few minutes.</div>
              : null
          }
        </div>
        <div>
          {
            nextPaymentDateLabel !== '' && !showChangePaymentFields && showChangePaymentButton ?
              inSettlement ?       
                <span>
                  <Popup wide hoverable content={<InSettlementPopup />} 
                    trigger={<span><Button disabled primary size={btnSize} content='Change Deposit' /></span>} 
                  />                              
                  <DepositInfoModal />
                </span>
                : 
                <span>
                  <Button primary onClick={this.changePayment} size={btnSize} content='Change Deposit' />                  
                  <DepositInfoModal />            
                </span>  
              : null
          }
        </div>
        </Responsive>

        <Modal open={adjustmentModalOpen} onClose={this.closeAdjustmentModal} closeOnDimmerClick={false} closeOnEscape={false} >
          <Modal.Header>Plan Adjustment</Modal.Header>
          <Modal.Content>
            <p>
              You've requested a reduction in your next deposit of <b>{DOLLAR_FORMAT.format(reductionAmount)}</b>. 
              We want to make sure you end up with enough in your account to arrange settlements with all of your creditors, 
              so let us know how you'd like us to add to the amount of your future deposits to make up the difference. 
            </p>
            <p>
              Choose an option below:
            </p>       
            <table>
              <tbody>
                {
                  monthCount > 0 ?
                    <tr>
                      <td>
                        <Radio
                          name='adjustmentType'
                          value='monthly'
                          checked={selectedAdjustmentType === 'monthly'}
                          onChange={this.handleOnAdjustmentTypeChange}
                        />
                      </td>
                      <td>Add <b>{DOLLAR_FORMAT.format(addToMonthAmount)}</b> to each of my next</td>
                      <td>
                        <Dropdown            
                          button
                          className='icon'
                          fluid
                          labeled
                          icon='caret square down outline'
                          options={monthOptions}
                          value={selectedAdjustmentMonth}
                          onChange={this.handleOnAdjustmentMonthChange}
                        />
                      </td>
                      <td>deposit(s). </td>
                    </tr>
                  : null
                }   
                <tr>
                  <td>
                    <Radio
                      name='adjustmentType'
                      value='addPayment'
                      checked={selectedAdjustmentType === 'addPayment'}
                      onChange={this.handleOnAdjustmentTypeChange}
                    />
                  </td>
                  <td colSpan="3">
                    Add a payment of <b>{DOLLAR_FORMAT.format(reductionAmount)}</b> on <b>{extendProgramDateLabel}</b>.
                  </td>
                </tr>
              </tbody>
            </table>     
            {
              adjustmentPlanErrors ?
                <Message size="tiny" error>
                  <Message.Header>
                    Validation Error(s):
                  </Message.Header>
                  <Message.List>
                    <Message.Item>Please select an adjustment option</Message.Item>
                  </Message.List>
                </Message>
                : null
            }
          </Modal.Content>
          <Modal.Actions>
            <div className="divActionButtonLeft">
              <Button negative size={btnSize} onClick={this.closeAdjustmentModal}>
                Cancel Changes
              </Button>
              <span className="divRight">
                <Button primary size={btnSize} onClick={this.savePlanAdjustmentChanges} >
                  Save Changes
                </Button>
              </span>
            </div>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/DepositsList/index.js